<div class="display-table errorpage">
  <div class="display-cell er-crd-bk">
    <div class="container">
      <div class="logincard er-tm-bk">
        <div class="error-logo">
          <img src="assets/img/MerchLoop-Iconwithtext-p-500.png" />
        </div>
        <div>
          <div *ngIf="isSuccess && !isError">
            <h4>Your email has been confirmed successfully. </h4>
          </div>
          <div *ngIf="!isSuccess && isError">
            <h4>An error occured, Please try again.</h4>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugia</p>   -->
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
